import { IStore } from 'Store/.';
import { createSelector } from 'reselect';

const getIsFetchingCustomerService = (state: IStore) => state.infoCustomerService.isFetching;
const getIsFetchCustomerServiceFailed = (state: IStore) => state.infoCustomerService.isFetchFailed;
const getCustomerServiceContent = (state: IStore) => state.infoCustomerService.content;

export {
  getIsFetchingCustomerService,
  getIsFetchCustomerServiceFailed,
  getCustomerServiceContent,
};


// WEBPACK FOOTER //
// ./src/components/InfoCustomerService/Redux/selectors.tsx